import React from 'react';
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { BarChart3 } from "lucide-react";
import { SignalSidePanelBacktest } from './signal_side_panel/SignalSidePanelBacktest';
import { SignalSidePanelPortfolio } from './signal_side_panel/SignalSidePanelPortfolio';
import { SignalSidePanelGuide } from './signal_side_panel/SignalSidePanelGuide';
import { SignalSidePanelFeatures } from './signal_side_panel/SignalSidePanelFeatures';
import { PortfolioBacktestModal } from './signal_side_panel/PortfolioBacktestModal';

interface SignalSidePanelProps {
  activeInfoTab: 'backtest' | 'portfolio' | 'guide';
  setActiveInfoTab: (tab: 'backtest' | 'portfolio' | 'guide') => void;
  backtestPeriod: '15m' | '30m' | '1h' | '4h';
  setBacktestPeriod: (period: '15m' | '30m' | '1h' | '4h') => void;
  strategy_type: string;
  symbol: string;
}

export const SignalSidePanel: React.FC<SignalSidePanelProps> = ({
  activeInfoTab,
  setActiveInfoTab,
  backtestPeriod,
  setBacktestPeriod,
  strategy_type,
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <Card className="w-full lg:w-[450px] bg-card shadow-sm border border-border rounded-2xl overflow-hidden shrink-0 lg:sticky lg:top-4 self-start">
      <CardHeader className="bg-muted/30 border-b border-border p-5">
        <div className="flex flex-col gap-3">
          <h3 className="text-base font-black flex items-center gap-2">
            <BarChart3 className="w-4 h-4 text-primary" />
            전략 레퍼런스 & 분석
          </h3>
          <div className="flex bg-muted p-1 rounded-xl gap-1">
            <button
              type="button"
              onClick={() => setActiveInfoTab('backtest')}
              className={`flex-1 py-1.5 text-xs font-bold rounded-lg transition-all ${activeInfoTab === 'backtest'
                ? 'bg-background shadow-xs text-foreground'
                : 'text-muted-foreground hover:text-foreground'
                }`}
            >
              백테스트 결과
            </button>
            <button
              type="button"
              onClick={() => setActiveInfoTab('portfolio')}
              className={`flex-1 py-1.5 text-xs font-bold rounded-lg transition-all ${activeInfoTab === 'portfolio'
                ? 'bg-background shadow-xs text-foreground'
                : 'text-muted-foreground hover:text-foreground'
                }`}
            >
              포트폴리오
            </button>
            <button
              type="button"
              onClick={() => setActiveInfoTab('guide')}
              className={`flex-1 py-1.5 text-xs font-bold rounded-lg transition-all ${activeInfoTab === 'guide'
                ? 'bg-background shadow-xs text-foreground'
                : 'text-muted-foreground hover:text-foreground'
                }`}
            >
              전략별 상세 가이드
            </button>
          </div>
        </div>
      </CardHeader>

      <CardContent className="p-5 max-h-[70vh] overflow-y-auto">
        <div className="space-y-5">
          {activeInfoTab === 'backtest' && (
            <SignalSidePanelBacktest
              backtestPeriod={backtestPeriod}
              setBacktestPeriod={setBacktestPeriod}
            />
          )}

          {activeInfoTab === 'portfolio' && (
            <SignalSidePanelPortfolio
              onOpenModal={() => setIsModalOpen(true)}
            />
          )}

          {activeInfoTab === 'guide' && (
            <SignalSidePanelGuide strategy_type={strategy_type} />
          )}
        </div>

        <div className="pt-4 border-t border-border/60 mt-6">
          <h3 className="text-sm font-black flex items-center gap-2 mb-3">
            <BarChart3 className="w-4 h-4 text-primary" />
            전략 엔진 도움말 및 팁
          </h3>
          <SignalSidePanelFeatures />
        </div>
      </CardContent>

      <PortfolioBacktestModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </Card>
  );
};
